import {useClientStorage} from "@/stores/store";
import {LS} from "@/shared/services/translate";
import {CONST_ADMIN_PATH, DEFAULT_LANGUAGE_CODE} from "@/shared/constants/consts";
import {useRoute} from "vue-router";


export const getRubricName = (rubrics, rubric_id) => {
    const rubric_obj = rubrics.find(function(x) { return x.id == rubric_id});

    if(rubric_obj) {
        return  LS(rubric_obj.name);
    }

    return '';
}

export const getArticleName = (article, article_id) => {
    const lang = useClientStorage().clientObj.lang;

    const article_obj = article.find(function(x) { return x.id == article_id && Object.getOwnPropertyDescriptor(x.content_lang, lang)});

    if(article_obj) {
        return  article_obj.content_lang[lang].title;
    }

    return '';
}

export const getTransformArticles = (articles, rubric_id = null) => {
    const route = useRoute();
    const clientStorage = useClientStorage();

    const lang = clientStorage.clientObj.lang;

    let rubric_articles = [];
    for (let i in articles)
    {
        let articleObj = articles[i];

        const is_admin_page = route.path === CONST_ADMIN_PATH;
        const lang_temp = is_admin_page ? DEFAULT_LANGUAGE_CODE : lang;

        const has_content_lang = Object.prototype.hasOwnProperty.call(articleObj.content_lang, lang_temp);
        const result_lang = has_content_lang ? lang_temp : (lang_temp == DEFAULT_LANGUAGE_CODE ? 'en' : DEFAULT_LANGUAGE_CODE);

        if(
            Object.prototype.hasOwnProperty.call(articleObj.content_lang, result_lang) &&
            (rubric_id == null || articleObj.rubric_id == rubric_id)
        ) {
            let {...content_lang} = articleObj.content_lang[result_lang];

            if(route.path !== CONST_ADMIN_PATH && content_lang.status != 1) {
                continue;
            }

            let languages = Object.keys(articleObj.content_lang)?.join(', ');

            articleObj['content_by_lang'] = content_lang;
            articleObj['languages'] = languages;

            rubric_articles.push(articleObj);
        }
    }

    return rubric_articles;
}
